import { makeStyles, Theme } from '@material-ui/core/styles';
import { FontWeightProperty } from 'csstype';

export const useStyles = makeStyles((t: Theme) => ({
  root: {
    fontSize: '34px',
    fontWeight: t.typography.fontWeightBold as FontWeightProperty,
  },
}));
